import { __rest } from "tslib";
import React from 'react';
import Div100vh from 'react-div-100vh';
export default function FullHeight(_a) {
    var { children } = _a, rest = __rest(_a, ["children"]);
    return React.createElement(Div100vh, Object.assign({}, rest), children);
}
